import { db } from "../../firebase";
import { doc, getDoc } from "firebase/firestore";
import { getLocalStorageItem } from "../localStorage/getLocalStorage";

const getSubCategory = async () => {
  try {
    const PropertyDynamicFieldsDoc = await doc(
      db,
      "clients",
      getLocalStorageItem("bid"),
      "dynamicFields",
      "property"
    );

    const d = await getDoc(PropertyDynamicFieldsDoc);
    return d.data().propertyCategories;
  } catch (error) {
    console.log(error);
    return false;
  }
};

export default getSubCategory;
